<template>
  <div class="block-wrap">
    <BlockTitle title-type="tourist">
      <!--<div>更多风景》</div>-->
    </BlockTitle>
    <div class="content-wrap">
      <div class="intro-box">
        <h3 class="title">{{ activeItem.name }}</h3>
        <div class="desc">{{ activeItem.desc }}</div>
        <!--<div class="card-more">查看详情</div>-->
      </div>
      <div class="view-box">
        <div class="card-list-wrap" :style="listWrapStyle">
          <div
            class="card-item"
            :class="activeIndex === index ? 'active' : ''"
            @click="onCardClick(index)"
            v-for="(item, index) in cardList"
            :key="index"
          >
            <img class="card-img" :src="item.imgSrc" alt="" />
            <div class="cover">
              <div class="cover-bg"></div>
              <div class="card-text-en">{{ item.en }}</div>
              <div class="card-text-zh">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="prev-button" @click="onPrev()"></div>
      </div>
    </div>
    <SplitLine />
  </div>
</template>

<script>
import BlockTitle from "@/components/BlockTitle";

import xh from '../../assets/tempImages/index/xh.jpg';
import wmjy from '../../assets/tempImages/index/wmjy.jpg';
import pts from '../../assets/tempImages/index/pts.jpg';
import hyqy from '../../assets/tempImages/index/hyqy.jpg';
import yds from '../../assets/tempImages/index/yds.jpg';
import ssld from '../../assets/tempImages/index/ssld.jpg';
import tts from '../../assets/tempImages/index/tts.jpg';
import jhsld from '../../assets/tempImages/index/jhsld.jpg';
import mgs from '../../assets/tempImages/index/mgs.jpg';
import xds from '../../assets/tempImages/index/xds.jpg';
import jyxd from '../../assets/tempImages/index/jyxd.jpg';
import zjwx from '../../assets/tempImages/index/zjwx.jpg';
import tzxj from '../../assets/tempImages/index/tzxj.jpg';
import jsjls from '../../assets/tempImages/index/jsjls.jpg';
import wcbzj from '../../assets/tempImages/index/wcbzj.jpg';
import ykfy from '../../assets/tempImages/index/ykfy.jpg';

export default {
  data() {
    return {
      cardList: [
        {
          title: "西湖",
          name: "杭州西湖风景名胜区",
          desc: "杭州西湖风景名胜区，位于浙江省杭州市中心，分为湖滨区、湖心区、北山区、南山区和钱塘区；秀丽的湖光山色和众多的名胜古迹闻名中外，是中国著名的旅游胜地，也被誉为人间天堂。景区内群山高度都不超过400米。",
          en: "XI HU",
          imgSrc: xh
        },
        {
          title: "五美景园",
          name: "五美景园风景名胜区",
          desc: "五美景园位于大罗山西侧，茶山镇罗丰村。由实际禅寺、逆川墓、顾公洞、莲花岩、金锁岭、观音洞、纺车岩、瞿丝潭及卧龙潭等组成。五美景园是大罗山内花岗岩地貌景观最为典型与集中的地区，岩石造型奇特，洞府景观幽深、奥妙，卧龙溪峡谷、瀑布景观壮美、险峻。",
          en: "Five Views Garden",
          imgSrc: wmjy
        },
        {
          title: "普陀山",
          name: "普陀山风景名胜区",
          desc: "普陀山地形呈菱形状，是舟山群岛1390个岛屿中的一个小岛，形似苍龙卧海，面积12.52平方千米，与舟山群岛的沈家门隔海相望，素有“海天佛国”、“南海圣境”之称，南北长8.6千米，东西宽约3.5千米，岸线长30千米。中部佛顶山天灯台最高，海拔291.2米，向四面延伸，西为茶山，北为伏龙山，东为青鼓垒山，东南为锦屏山、莲台山、白华山，西南为梅岑山，主峰均在100至200米间，连绵起伏。",
          en: "Putuo Mountain",
          imgSrc: pts
        },
        {
          title: "海盐绮园",
          name: "海盐绮园风景名胜区",
          desc: "绮园，位于浙江省嘉兴市海盐县武原镇，绮园原为“冯氏花园”，为江南典型私家园林风格。清同治九年（1870年），园主冯缵斋于此建宅三进；清同治十年（1871年），冯缵斋综合其岳父黄燮清经营的明代故园拙宜园、砚园两废园之精华，在自己住宅“冯三乐堂”后辟地修建园林，建成绮园。",
          en: "Haiyan Qiyuan",
          imgSrc: hyqy
        },
        {
          title: "雁荡山",
          name: "温州雁荡山",
          desc: "雁荡山位于中国东南温州市境和台州市南部。《载敬堂集》载：“雁荡山以瓯江自然断裂，分北雁荡山和南雁荡山。2005年2月，有‘古火山立体模型’之称的雁荡山被联合国教科文组织评为世界地质公园，以该公园管理机构和地质展示馆均在北雁荡山等因，北雁荡山或捷称雁荡山。”距杭州297公里，温州68公里。始开发于南北朝，兴于唐，盛于宋，素有“寰中绝胜”、“海上名山”之誉，史称“东南第一山”。广义的雁荡山景观，自北而南包括温岭的方山景区，乐清的显胜门景区、二灵景区、大龙湫景区，平阳的明王峰景区、石城景区和东西洞景区等。",
          en: "Wenzhou Yandangshan",
          imgSrc: yds
        },       
        {
          title: "嵊泗列岛",
          name: "舟山嵊泗列岛",
          desc: "嵊泗列岛是中国目前唯一的一处国家级列岛风景名胜区，西与上海芦潮港隔海相望，南临普陀山，东临浩瀚的太平洋，北接黄海。嵊泗列岛面积35平方公里，由钱塘江与长江入海口汇合处的数以百计的岛屿群构成，包括大洋山、小洋山、沈家湾岛、薄刀嘴岛等400多个大小岛屿，最大的岛屿泗礁山，面积21.2平方公里。8个大岛有人居住，基湖、南长涂两个姐妹沙滩相背而依，金沙绵延2000余米，滩缓沙净，风平浪静，海天辽阔，山水奇美，礁石星罗棋布，风景独特。嵊泗仿若海中明珠，镶嵌于碧波之上，阳光、海风、海滩创造了良好的避暑休养的环境，金色沙滩，湛蓝海水，海岛奇观，奇峰异石，渔港景色等，会使人充分感受到大自然的魅力。",
          en: "Zhoushan Shensi",
          imgSrc: ssld
        },
        {
          title: "天台山",
          name: "台州天台山",
          desc: "天台山位于中国浙江省天台县城北属仙霞岭分支，呈西南东北走向，平均海拔500米以上，主峰华顶山海拔1098米。名僧济公的故乡，佛教天台宗和道教南宗的发祥地。自然景观有华顶、琼台、赤城山等名山；仙人洞、吊船岩等怪岩；石梁飞瀑、水珠帘等瀑布。人文景观有国清、华顶、塔头等寺庙，以及古塔、碑刻等。天台山最著名的寺庙是建于隋代、重修于清雍正年间的国清寺，有殿宇14座、房屋余间，大殿中有明代铸造的重13吨的铜铸释迦牟尼坐像。国清寺是保存较完整的著名寺院。天台山自古闻名，王羲之、顾恺之、李白、苏东坡、陆游、徐霞客等人都在此留下足迹。天台山的景点也各有特色，可概括为古、清、奇、幽四个字。赤城栖霞、双涧回澜、华顶秀色、琼台月夜等被称为天台八景。",
          en: "Taizhou Tiantaishan",
          imgSrc: tts
        },
        {
          title: "双龙洞",
          name: "金华双龙洞",
          desc: "金华双龙洞距金华市区约8公里，坐落在海拔350-450多米的北山南坡，除底层的双龙洞之外，还有中层的冰壶洞和最高的朝真洞。双龙洞分内、外两洞，外洞高大明亮，洞高66余米，长、深各33余米，面积1200多平方米。洞内陈放着一排排石桌、石椅，可容千人品茶避暑。",
          en: "Jinhua Shuanglongdong",
          imgSrc: jhsld
        },
        {
          title: "德清莫干山",
          name: "德清莫干山",
          desc: "莫干山，为天目山之余脉，位于浙江省北部德清县境内，美丽富饶的沪、宁、杭金三角的中心，国家重点风景名胜区。因春秋末年，吴王阖闾派干将、莫邪在此铸成举世无双的雌雄双剑而得名，是中国著名的度假休闲旅游及避暑胜地。莫干山山峦连绵起伏，风景秀丽多姿，景区面积达43平方公里，它虽不及泰岱之雄伟、华山之险峻，却以绿荫如海的修竹、清澈不竭的山泉、星罗棋布的别墅、四季各异的迷人风光称秀于江南，享有江南第一山之美誉。",
          en: "Deqing Moganshan",
          imgSrc: mgs
        },
        {
          title: "雪窦山",
          name: "奉化雪窦山",
          desc: "雪窦山风景区，位于浙江省奉化市溪口镇西北，为四明山支脉的最高峰，海拔800米。有四明第一山之誉。山上有乳峰，乳峰有窦，水从窦出，色白如乳，故泉名乳泉，窦称雪窦，山名亦因此得名，风景区包括溪口镇、雪窦山、亭下湖三部分。有千丈岩、三隐潭瀑布、妙高台、商量岗、林海等景观。",
          en: "Fenghua Xuedoushan",
          imgSrc: xds
        },
        {
          title: "缙云仙都",
          name: "缙云仙都",
          desc: "仙都原名缙云山，位于缙云县城东7公里处。有鼎湖峰、倪翁洞、小赤壁、姑妇岩、铁城、仙人剖瓜、马鞍等4个游览区，包括72奇峰，29名洞和18处古迹，其中以奇特雄伟的鼎湖峰最为著名，其峰顶有常年积水的小湖，湖四周苍松翠柏掩映。有 “天下第一峰”、“天下第一笋”之称。",
          en: "Jingyunxiandu",
          imgSrc: jyxd
        },
        {
          title: "诸暨五泄",
          name: "诸暨五泄",
          desc: "诸暨五泄在诸暨市西30公里群山之中。所谓“泄”，就是瀑布之意。瀑从五泄山巅的崇崖峻壁间飞流而下，折为五级，总称“五泄溪”。溪两岸异峰怪石，争奇竞秀，有“72峰，36洞，25崖”，得崖壑飞瀑之胜。五泄风光以青山挺秀、飞泉成泄而著称。",
          en: "Zhujiwuxie",
          imgSrc: zjwx
        },
        {
          title: "台州仙居",
          name: "台州仙居",
          desc: "仙居风景名胜区位于仙居县的中南部。由西罨、景星、十三都、公盂、淡竹五个景区组成，以奇、险、清、幽为主要特点。是历代文人荟萃之地，留有众多踪迹。区内还有道教胜地括苍洞宫、南峰塔、兴道禅院、晋代（）摩崖石刻大佛字，以及摩崖蝌蚪文等古迹。",
          en: "Taizhou Xianju",
          imgSrc: tzxj
        },
        {
          title: "江郎山",
          name: "江山江郎山",
          desc: "江郎山在浙江省江山市城南25公里的江郎乡，是国家级的著名旅游风景区，更是如今国内不多的世界自然文化遗产之一。山形主体为三个高耸入云的巨石，传说是古时候三个姓江的兄弟登上山顶变成为三大巨石而形成，所以又叫江郎山。三巨石拔地冲天而起，高360余米。",
          en: "Jianglangshan",
          imgSrc: jsjls
        },
        {
          title: "文成百丈漈",
          name: "文成百丈漈",
          desc: "百丈漈风景名胜区位于文成县境内，距文成县城4公里，距温州市区115公里，面积170平方公里，海拔800余米，地势自西向东，为洞宫山脉延伸段。是一处集湖光山色之大成，融自然人文景观为一体，具有瀑雄、峰奇、湖秀、潭丽等特点的高品位旅游、避暑的休养胜地。周围20余公里，是一个高山平原。物华天宝，人杰地灵。北宋《太平寰宇记》称：“天下七十二福地，南田居其一，万山深处忽辟平畴，高旷绝尘，风景如画，桃源世外无多让焉。",
          en: "Wenchengbaizhangji",
          imgSrc: wcbzj
        },
        {
          title: "永康方岩",
          name: "永康方岩",
          desc: "方岩风景名胜区位于浙江永康市景区总面积达92平方公里。是植根于丹霞地貌的山水奇葩.全区包括方岩山、五峰、南岩、石鼓寮、灵山湖、刘英烈士陵园、五指岩、太平湖等八大景区。方岩山是方岩风景名胜区的中心景观，以雄奇峻险著称，是丹霞地貌特征最明显、发育最完全的区域，可与武夷山风景区的岩体相媲美。方岩山高400米，方圆约3000米，平地突兀，四壁如削，峰顶与峰脚面积相差无几，气势雄伟，酷似擎天方柱。",
          en: "Yongkangfangyan",
          imgSrc: ykfy
        },
        
      ],
      activeIndex: 0,
    };
  },
  computed: {
    activeItem() {
      return this.cardList[this.activeIndex];
    },
    listWrapStyle() {
      return `left: -${this.activeIndex * 320}px`;
    },
  },
  components: {
    BlockTitle,
  },
  methods: {
    onCardClick(index) {
      this.activeIndex = index;
    },
    onPrev() {
      if (this.activeIndex === this.cardList.length - 1) {
        this.activeIndex = 0;
      } else {
        this.activeIndex++;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.block-wrap {
  overflow: hidden;
  
  .content-wrap {
    margin-top: 50px;
    margin-bottom: 57px;
    height: 480px;
    position: relative;

    .intro-box {
      width: 240px;
      height: 100%;
      padding-top: 80px;
      position: absolute;
      left: 0;
      top: 0;
      .title {
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #131415;
        line-height: 33px;
        margin-bottom: 12px;
      }

      .desc {
        &:extend(.line6);
        height: 144px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        line-height: 24px;
        margin-bottom: 36px;
      }

      .card-more {
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #f1f3f3;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        text-align: center;
        cursor: pointer;

        &:hover {
          color: #06ae63;
        }
      }
    }

    .view-box {
      width: 1200px;
      height: 100%;
      position: absolute;
      left: 256px;
      top: 0;
      overflow: hidden;

      .card-list-wrap {
        height: 100%;
        padding: 0 20px;
        display: flex;
        align-items: flex-end;
        position: absolute;
        left: 0;
        top: 0;
        transition: all 0.4s ease-in;

        .card-item {
          width: 300px;
          height: 400px;
          flex: 1 1 auto;
          margin-right: 20px;
          position: relative;
          transition: height 0.4s ease-in;
          cursor: pointer;

          &.active {
            height: 480px;
            box-shadow: 0px 10px 20px 10px rgba(10, 35, 18, 0.08);
            border: 4px solid #06ae63;

            .cover {
              display: none;
            }
          }

          .card-img {
            display: block;
            width: 100%;
            height: 100%;
          }

          .cover {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .cover-bg {
              background: #0a2312;
              opacity: 0.35;
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
            }

            .card-text-en {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #fdfffd;
              line-height: 33px;
              margin-bottom: 4px;
            }

            .card-text-zh {
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #fdfffd;
              line-height: 40px;
            }
          }
        }
      }

      .prev-button {
        width: 44px;
        height: 44px;
        background-image: url(../../assets/images/arrow.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-22px);

        &:hover {
          background-image: url(../../assets/images/arrow-active.png);
        }
      }
    }
  }
}
</style>